export default "__VITE_ASSET__Bp5up$fs__ 1200w";